// Action types for sidebar
export const SET_SIDEBAR = 'SET_SIDEBAR';

// Action types for users
export const LOADING_USERS = 'LOADING_USERS';
export const GET_USERS = 'GET_USERS';
export const UPDATE_USER = 'UPDATE_USER';
export const DELETE_USER = 'DELETE_USER';
export const INVITE_USER = 'INVITE_USER';
export const GET_USER_STEPS = 'GET_USER_STEPS';
